import { Upload } from "antd";
import { useEffect } from "react";
import { Api } from "../../uikit/service/api";
import styles from "../components-css/DragDropFile.module.css";
import func from "@uikit/func";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

export default function DragDropFile(props) {
  const { Dragger } = Upload;

  const api = new Api(false);

  const beforeUpload = (file, files) => {
    // only support one file
    if (props.fileList.length > 0) {
      func.customMsg({
        content: "Only one file can be uploaded",
        type: "warning",
      });
      return false;
    }
    props.setFileList([file]);
    return true;
  };
  const removeFile = () => {
    props.setFileList([]);
  };
  const uploadS3 = () => {
    const file = props.fileList[0];
    file.status = "uploading";
    props.setFileList([file]);
    const form = new FormData();
    form.append("file", file, file.name);
    api
      .postOtherTypeDataWithError(`/api/me/upload/studios`, form)
      .then(res => {
        file.status = "success";
        file.s3Path = res?.data?.object_key;
        file.s3Url = res?.data?.object_s3_url || res?.data?.s3_https_url || "";
        props.setFileList([file]);
        if (!file.s3Path) {
          throw Error("Failed to get s3 path");
        }
      })
      .catch(error => {
        console.error(error);
        func.messageError(error);
        file.status = "error";
        props.setFileList([file]);
      });
  };

  useEffect(() => {
    if (func.isEmpty(props.fileList)) return;
    if (props.fileList[0].status !== "success") {
      uploadS3();
    }
  }, [props.fileList?.[0]]);

  return (
    <Dragger
      name="file"
      className={styles.dragger}
      multiple={false}
      onRemove={removeFile}
      customRequest={() => {}}
      beforeUpload={beforeUpload}
      fileList={props.fileList}
    >
      <div className={styles.upload}>
        <div className={styles.icon}>
          <img alt="" src={`${settings.S3CDN}${settings.viewAssetsPath}upload.svg`} />
        </div>
        <div className={styles.desc}>Drag and drop your files here to upload them.</div>
        <div className={styles.limitSize}>50 Mb max file size.</div>
      </div>
    </Dragger>
  );
}
